/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const heart_rate_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m17.033 16.583-4.492 4.686a.749.749 0 0 1-1.082 0l-4.493-4.687m-5.495-5.995a5.675 5.675 0 0 1 1.592-7.333 5.673 5.673 0 0 1 7.371.559L12 5.373l1.566-1.565a5.673 5.673 0 0 1 8.966 6.774m-19.782 3h4.518a.377.377 0 0 0 .336-.206l1.723-3.447a.376.376 0 0 1 .7.06l1.681 5.6a.376.376 0 0 0 .7.04l1.57-3.664a.376.376 0 0 1 .657-.061l1.116 1.674h5.5"
    />
  </svg>
)
export default heart_rate_medium
